<template>
  <div class="fulldashboard">
      <div class="container">
          
        <div class="intro h-100">
            <div class="row h-100 align-items-center">
              <div class="col-md-6 ml-3">
                    <h3>Passwort verwalten</h3>
                 <p>
                   Hier kannst du dein Passwort verwalten 
                 </p>
              </div>
            </div>
          </div>
          <div class="passwortResetFormat">
          <div class="profile-content">
                <div class="tab-pane fade pt-3" id="account" role="tabpanel" aria-labelledby="account-tab">
                  <div class="container">
                      <div class="row">
                        
                        <div class="col-md-12">
                          <div class="form-group ">
                            <input type="text"  v-model="currentPassword" placeholder="Aktuelles Passwort" class="form-control">
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <input type="text"  v-model="newPassword" placeholder="Neues Passwort" class="form-control">
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <input type="text"  v-model="repeatPassword" placeholder="Neues Passwort wiederholen" class="form-control">
                          </div>
                        </div>

                        <div class="col-md-4 ">
                          <div class="form-group">
                              <input   type="button" v-on:click="tryLogin" value="Änderung speichern" class="btn btn-success w-100">
                          </div>
                        </div>
                        
                      </div>
                      <div v-if="!isHidden" :class="[alertClass,'alert']" >{{ alertMassage }}</div>
                  </div>
                </div>
           </div>
           </div>
      </div>
    </div>
     
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

export default {

  computed: {
      // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
          user: "user"
      }),
      alertClass(){
        return this.success?'alert-success':'alert-error'
      }
    },
  data(){
    return {
        currentPassword: '',
        newPassword: '',
        repeatPassword: '',
        alertMassage:'',
        success: false,
        isHidden: true
    }
  },
  methods:{
      clearTextfields(){
        this.newPassword = ''
        this.repeatPassword = ''
        this.currentPassword = ''
      },
      async tryLogin(){
        this.alertMassage = ''
        const email = firebase.auth().currentUser.email
        this.isHidden = true 
          firebase
                    .auth()
                    .signInWithEmailAndPassword(email, this.currentPassword)
                    // eslint-disable-next-line no-unused-vars
                    .then(() => {
                        this.resetPassword()
                    })
                    .catch(err => {
                        this.alertMassage = err
                        this.isHidden = false 
                    });
      },
      resetPassword(){
          var user = firebase.auth().currentUser
          var newPassword = this.newPassword

          if (this.newPassword == this.repeatPassword){
              user.updatePassword(newPassword).then(() => {
              this.clearTextfields()
              this.isHidden = false
              this.alertMassage = 'Passwort erfolgreich geändert'
              this.success = true 
            }).catch(function(error) {
              this.isHidden = false
              this.alertMassage = error
          })      
          } else {
            this.success = false
            this.isHidden = false
            this.alertMassage = 'Passwörter stimmen nicht überein'
          } 
      }
      
    }
  
}
</script>

<style lang="scss" scoped>
.passwortResetFormat{
  width: 400px;
}
.alert{
  padding: 5px;
  &-error{
    color:red;
  }
  &-success{
    color: rgb(8, 212, 8);
  }
}

</style>
